module.exports = __webpack_public_path__ + "static/img/image63.0a90e93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c35/image63.png
// module id = oPZB
// module chunks = 0